module.exports = __webpack_public_path__ + "img/logo.aecc7e3e.png";